/* eslint-disable linebreak-style */
import { Component, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';
import { BranchStoreSelected } from 'src/app/pages/gestion/branch-stores/components/details/branch-store-details.component';
import { ProviderSelected } from 'src/app/pages/gestion/providers/components/details/provider-details.component';
import { MessageService } from 'primeng/api';
import { CartPurchaseOrderService } from '../../purchase-order/utils-components/cart/cart-purchase-order.service';

import { PurchaseOrderSelected } from '../../purchase-order/select/purchase-order-select-details.component';
import { PurchaseOrderService } from '../../purchase-order/purchase-order.service';
import { PurchaseOrderInvoiceService } from '../purchase-order-invoice.service';
import {
  IPurchaseOrderInvoice,
  ProductsPurchaseOrderInvoiceBody
} from '../purchase-order-invoice.interface';

@Component({
  selector: 'pg-purchase-order-invoice-create',
  templateUrl: './purchase-order-invoice-create.component.html',
  providers: [MessageService]
})
export class PurchasesOrderInvoiceCreateComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  purchaseOrderSelected = new PurchaseOrderSelected(
    'Ordenes de Compras Aprobadas'
  );
  payload;
  productsPurchaseOrderSelected;
  branchStoreOriginSelected = new BranchStoreSelected('Sucursal Origen');
  select = {
    purchaseOrder: {
      openDialog: false,
      id: null
    }
  };
  quantityReceived;
  accumulatedQuantity: number;
  orderedQuantity: number;
  newInvoiceStatusId: number;
  constructor(
    private fb: FormBuilder,
    private serviceBaseJoin: PurchaseOrderInvoiceService,
    private cartPurchaseOrderService: CartPurchaseOrderService,
    private messageService: MessageService,
    private purchaseOrderService: PurchaseOrderService
  ) {
    super('', serviceBaseJoin);
  }

  ngOnInit(): void {
    this.fg = this.fb.group({
      issue_at: [null, [Validators.required]],
      numberDocument: [null, [Validators.required]]
    });
  }

  async onSubmit() {
    const productsPayload: ProductsPurchaseOrderInvoiceBody[] =
      this.buildProductsBody();
    if (this.purchaseOrderSelected.getId() == undefined) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Campos sin completar',
        detail: 'Recuerda seleccionar una Orden de Compra Aprobada'
      });
      return;
    }
    for (const value of Object.values(this.fg.value)) {
      if (value == null || value == '' || value == undefined) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Campos sin completar',
          detail: 'Recuerda completar los campos de Detalles'
        });
        return;
      }
    }
    if (productsPayload.length == 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Carrito vacio',
        detail: 'Recuerda incluir los Productos del Proveedor'
      });
      return;
    }
    const purchaseOrderSelected = this.purchaseOrderSelected.getInfo();
    this.productsPurchaseOrderSelected = purchaseOrderSelected.products;
    this.quantityReceived = 0;
    for (const i in this.productsPurchaseOrderSelected) {
      for (const item of productsPayload) {
        if (
          this.productsPurchaseOrderSelected[i].id == item.purchaseOrderDetailId
        ) {
          this.productsPurchaseOrderSelected[i].quantity_invoiced +=
            item.quantity;
        }
      }
    }
    this.message = { message: 'Modificando stock de venta' };
    this.accumulatedQuantity = 0;
    this.orderedQuantity = 0;
    for (const i in this.productsPurchaseOrderSelected) {
      this.accumulatedQuantity +=
        this.productsPurchaseOrderSelected[i].quantity_invoiced;
      this.orderedQuantity += this.productsPurchaseOrderSelected[i].quantity;
    }

    if (this.orderedQuantity > this.accumulatedQuantity) {
      this.newInvoiceStatusId = 2;
    } else {
      this.newInvoiceStatusId = 3;
    }
    const fieldsToUpdate = {
      document: {
        providerId: purchaseOrderSelected.providerId,
        paymentTermsId: purchaseOrderSelected.paymentTermsId,
        taxId: purchaseOrderSelected.taxId,
        orderStatusId: purchaseOrderSelected.orderStatusId,
        receptionStatusId: purchaseOrderSelected.receptionStatusId,
        invoiceStatusId: this.newInvoiceStatusId,
        delivery_at: purchaseOrderSelected.delivery_at,
        numberDocument: purchaseOrderSelected.numberDocument
      },
      products: this.productsPurchaseOrderSelected
    };
    this.message = await this.purchaseOrderService.update(
      this.purchaseOrderSelected.getId(),
      fieldsToUpdate
    );

    this.payload = {
      document: {
        issue_at: this.fg.value['issue_at'] + 'T05:00:00.000Z',
        expiration_at: this.fg.value['issue_at'] + 'T05:00:00.000Z',
        purchaseOrderDocumentId: this.purchaseOrderSelected.getId(),
        numberDocument: this.fg.value['numberDocument']
      },
      products: productsPayload
    };
    this.createItem$(this.payload);
  }

  buildProductsBody(): ProductsPurchaseOrderInvoiceBody[] {
    const cartData = this.cartPurchaseOrderService.getData();
    const productsOrderedBody = cartData.map((stockProductOrdered) => {
      return {
        quantity: stockProductOrdered.quantity_cart,
        purchaseOrderDetailId: stockProductOrdered.id
      };
    });

    return productsOrderedBody;
  }

  isCartEmpty() {
    return this.cartPurchaseOrderService.isCartEmpty();
  }

  onSelectedPurchaseOrder(row: IPurchaseOrderInvoice) {
    if (row) {
      this.fg.controls.purchaseOrder.setValue(`${row.id} / ${row.ruc}`);
      this.select.purchaseOrder.id = row.id;
    }
    this.select.purchaseOrder.openDialog = false;
  }

  ngOnDestroy() {
    this.cartPurchaseOrderService.emptyData();
  }
}
